export const Chat = {
  chatRoomTypes: new Map([
    ['academyParent', '상담창구 - 학부모'],
    ['teacherParent', '개인적 대화 - 학부모'],
    ['academyStudent', '상담창구 - 학생'],
    ['teacherStudent', '개인적 대화 - 학생'],
  ]),
};
